module.exports = __webpack_public_path__ + "img/428837.b50d2657.png";